// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__15YvM","image":"App_image__3xLXH"};